import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers, } from "./config";


const RoleList = () => {

  return (
    <Table tableId="roles" title="Role" icon={InventoryRoundedIcon}  headers={headers} filters={filters} defaultSort="name" idKey="role_id" fieldsToSearch={['Name']} view={false} />
  );
};

export default RoleList;